import React from 'react';
import { Space, Tag, Button, Tooltip } from 'antd';
import { SyncOutlined, DeleteOutlined, AmazonOutlined, LinkOutlined } from '@ant-design/icons';
import { CompetitorASIN } from '../../../../../../../types';

export const getCompetitorColumns = (
    handleSync: (record: CompetitorASIN) => void,
    handleDelete: (recordId: number) => void,
    scrapping: Record<number, boolean>
) => [
        {
            title: '商品信息',
            key: 'info',
            width: 400,
            render: (_: any, record: CompetitorASIN) => (
                <Space align="start">
                    <div style={{ width: 60, height: 60, flexShrink: 0, border: '1px solid #f0f0f0', borderRadius: 4, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {record.image_url ? (
                            <img src={record.image_url} alt="product" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                        ) : (
                            <AmazonOutlined style={{ fontSize: 24, color: '#ccc' }} />
                        )}
                    </div>
                    <div>
                        <div style={{ fontWeight: 500, marginBottom: 4, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                            <a href={`https://www.amazon.com/dp/${record.asin}`} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                                {record.title || record.asin} <LinkOutlined style={{ fontSize: 12, color: '#1890ff' }} />
                            </a>
                        </div>
                        <Space size={4}>
                            <Tag color="blue">{record.brand || 'Unknown'}</Tag>
                            <span style={{ color: '#999', fontSize: 12 }}>ASIN: {record.asin}</span>
                        </Space>
                    </div>
                </Space>
            )
        },
        {
            title: '价格',
            key: 'price',
            width: 120,
            render: (_: any, record: CompetitorASIN) => (
                record.price ? (
                    <span style={{ fontWeight: 600, color: '#fa8c16' }}>
                        {record.currency === 'USD' ? '$' : record.currency} {record.price}
                    </span>
                ) : <span style={{ color: '#ccc' }}>--</span>
            )
        },
        {
            title: '威胁与备注',
            key: 'threat',
            width: 200,
            render: (_: any, record: CompetitorASIN) => (
                <Space direction="vertical" size={2}>
                    <div>
                        <span style={{ marginRight: 8 }}>威胁等级:</span>
                        <Tag color={
                            record.threat_level === 'high' ? 'red' :
                                record.threat_level === 'medium' ? 'orange' : 'green'
                        }>
                            {record.threat_level === 'high' ? '高' : record.threat_level === 'medium' ? '中' : '低'}
                        </Tag>
                    </div>
                    {record.notes && <div style={{ fontSize: 12, color: '#666' }}>{record.notes}</div>}
                </Space>
            )
        },
        {
            title: '状态',
            key: 'status',
            width: 150,
            render: (_: any, record: CompetitorASIN) => (
                <div style={{ fontSize: 12, color: '#666' }}>
                    <div>首次发现: {record.first_seen}</div>
                    <div>最近出现: {record.last_seen}</div>
                    <div>出现次数: {record.appearance_count}</div>
                </div>
            )
        },
        {
            title: '操作',
            key: 'action',
            width: 120,
            render: (_: any, record: CompetitorASIN) => (
                <Space>
                    <Tooltip title="同步详情">
                        <Button
                            type="text"
                            icon={<SyncOutlined spin={scrapping[record.id]} />}
                            onClick={() => handleSync(record)}
                        />
                    </Tooltip>
                    <Tooltip title="删除">
                        <Button
                            type="text"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => handleDelete(record.id)}
                        />
                    </Tooltip>
                </Space>
            )
        }
    ];
